<template>
    <v-row v-if="routine">
        <!-- LEFT SIDE -->
        <v-col cols="12" md="6">
            <div class="white-card">
                <v-row>
                    <!-- IMG -->
                    <v-col cols="12">
                        <v-img eager height="200" contain class="routine-img" :src="routineImg"/>
                    </v-col>
                    <!-- NAME -->
                    <v-col cols="12">
                        <div class="routine-name">
                            {{ routine.name }}
                        </div>
                        <div class="routine-text">
                            {{ routineBlocksExercises }}
                        </div>
                    </v-col>
                    <!-- BUTTONS -->
                    <v-col cols="12" class="text-center">
                        <v-btn v-if="canEdit" class="normal-btn mr-2" @click="editRoutine" outlined color="#797979" small>
                            {{ $t('routines.edit_routine') }}
                        </v-btn>
                        <v-btn class="normal-btn black--text" @click="assignRoutine" color="primary" small depressed>
                            {{ $t('routines.assign_routine') }}
                        </v-btn>
                    </v-col>
                    <!-- DIVIDER -->
                    <v-col cols="12">
                        <v-divider/>
                    </v-col>
                    <!-- CHART -->
                    <v-col cols="12">
                        <div class="routine-text bolder">
                            {{ routineOf }}
                        </div>
                        <div class="routine-text">
                            {{ $t('common.made_of') }}
                        </div>
                        <pie-chart style="height: 200px" :labels="labels" :datasets="datasets"/>
                    </v-col>
                </v-row>
            </div>
        </v-col>
        <!-- RIGHT SIDE -->
        <v-col cols="12" md="6">
            <div class="white-card">
                <!-- BLOCKS -->
                <routine-blocks readonly :defaultBlocks="routine.blocks"
                                @click:exercise="onClickExercise($event)" force-cols12/>
            </div>
        </v-col>

        <exercise-dialog :is-third-dialog="isThirdDialog" ref="exerciseDialog"/>

    </v-row>
</template>

<script>

import ExerciseDialog from '@/components/common/routines/ExerciseDialog'
import RoutineBlocks from '@/components/coach/routines/RoutineBlocks'
import {mapActions, mapState} from "vuex";
import PieChart from "@/components/common/PieChart";

export default {
    props: {
        routine: {
            type: Object,
            default: {},
        },
        isThirdDialog: {
            type: Boolean,
            default: false,
        },
        copyRoutine: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        PieChart,
        ExerciseDialog,
        RoutineBlocks,
    },
    data() {
        return {
            routineCreator: '...',
            loadingCopy: false,
            datasets: [],
            labels: [],
            colors: ['#99CC00', '#797979', '#2C3149', '#078571', '#66CCCC']
        }
    },
    computed: {
        ...mapState(['equipment']),
        isCompany(vm = this) {
            return vm.account?.accountType === 'company'
        },
        isOwner(vm = this) {
            return vm.routine?.coachId === vm.currentUser?.uid
        },
        canEdit(vm = this) {
            return vm.isOwner || vm.isCompany
        },
        routineImg(vm = this) {
            return vm.routine?.img || vm.imgPlaceholder
        },
        routineBlocksExercises(vm = this) {
            let qtyBlocks = vm.routine.blocks.length || 0
            let qtyExercises = 0
            vm.routine.blocks.forEach(block => qtyExercises += block.exercises?.filter(exercise => exercise.type === 'exercise')?.length || 0)
            return `${qtyBlocks} ${vm.$tc('common.blocks', qtyBlocks)} / ${qtyExercises} ${vm.$tc('exercises.exercises', qtyExercises)}`
        },
        routineOf(vm = this) {
            if (vm.routine?.description?.objective) return `${vm.$t('routines.routine_of')} ${vm.routine?.description?.objective}`
            return vm.$t('common.routine')
        },
    },
    async mounted() {
        const vm = this
        if (vm.equipment.length === 0) await vm.bindEquipment()
        await vm.loadRoutineChart()
    },
    methods: {
        ...mapActions(['bindEquipment']),
        editRoutine() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.routines.edit`, params: {uid: vm.$route.params.uid}})
        },
        exerciseImg(exercise) {
            const vm = this
            return exercise?.img || vm.imgPlaceholder
        },
        assignRoutine() {
            const vm = this
            vm.loadingCopy = true
            vm.$emit('selectRoutine', vm.routine)
            vm.loadingCopy = true
        },
        equipImg(equip) {
            let vm = this
            return vm.equipment?.find(el => el.name === equip)?.src || vm.imgPlaceholder
        },
        onClickExercise(exercise) {
            const vm = this
            vm.$refs.exerciseDialog.show()
            vm.$refs.exerciseDialog.setExercise(exercise)
        },
        async loadRoutineChart() {
            const vm = this
            if (!vm.routine) return;
            let data = []
            let labels = []

            vm.routine.blocks.forEach(block => {
                block.exercises.forEach(exercise => {
                    if (exercise.type === 'exercise' && exercise.categories) labels.push(...exercise.categories)
                })
            })
            vm.labels = [...new Set(labels)]

            vm.routine.blocks.forEach(block => {
                vm.labels.forEach((label, i) => {
                    if (!data[i]) data[i] = 0
                    data[i] += block.exercises.filter(exercise => exercise.categories?.includes(label)).length || 0
                })
            })

            vm.datasets = [{
                data: data,
                backgroundColor: vm.colors,
            }]
        }
    },
    watch: {
        routine() {
            const vm = this
            vm.loadRoutineChart()
        }
    }
}
</script>

<style scoped>

.routine-img {
    background-color: rgba(0, 0, 0, .05);
    border-radius: 8px;
}

.routine-name {
    font-size: 30px;
    line-height: 38px;
    color: #03342C;
    font-weight: bold;
}

.routine-text {
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    color: #797979;
}

.v-divider {
    border-color: #797979;
    border-radius: 4px;
}

</style>